module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.filteredRanking) ? _c('div', [_vm._v("\n        " + _vm._s(_vm.rankingGroup.name) + "\n        "), _c('table', {
    staticClass: "row column ranking"
  }, _vm._l((_vm.filteredRanking), function(ranking_line, i) {
    return _c('tr', {
      class: {
        win: i < 9, lose: i >= 9
      },
      attrs: {
        "id": ranking_line.team.id
      },
      on: {
        "click": function($event) {
          return _vm.teamClicked(ranking_line.team.id)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(i + 1) + ".")]), _vm._v(" "), _c('td', [_c('img', {
      staticClass: "small-team-icon",
      attrs: {
        "src": _vm.getRosterIcon(ranking_line.team.ref_roster),
        "alt": "team"
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ranking_line.team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ranking_line.ranking_points) + " pts")])])
  }), 0)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9fa86790"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/ranking-group-panel.vue
// module id = 787
// module chunks = 0